var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCopyLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#CCCCCC"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3588_4477)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4987 18.75C16.8208 19.1806 17.2317 19.5369 17.7036 19.7947C18.1755 20.0525 18.6973 20.2058 19.2337 20.2442C19.7701 20.2826 20.3084 20.2052 20.8122 20.0173C21.316 19.8294 21.7736 19.5353 22.1537 19.155L24.4037 16.905C25.0868 16.1977 25.4648 15.2505 25.4562 14.2672C25.4477 13.284 25.0533 12.3434 24.358 11.6482C23.6628 10.9529 22.7222 10.5585 21.739 10.5499C20.7557 10.5414 19.8085 10.9194 19.1012 11.6025L17.8112 12.885M19.4987 17.25C19.1766 16.8194 18.7657 16.4631 18.2938 16.2053C17.8219 15.9475 17.3001 15.7941 16.7637 15.7557C16.2273 15.7173 15.689 15.7947 15.1852 15.9826C14.6814 16.1706 14.2238 16.4647 13.8437 16.845L11.5937 19.095C10.9106 19.8022 10.5326 20.7495 10.5412 21.7327C10.5497 22.716 10.9441 23.6565 11.6394 24.3518C12.3346 25.0471 13.2752 25.4415 14.2584 25.45C15.2417 25.4586 16.1889 25.0806 16.8962 24.3975L18.1787 23.115",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3588_4477"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(9 9)"
})))));
export default SvgIconCopyLink;